import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  Paper,
  Typography
} from '@mui/material';

import {
  EditOutlined
} from '@mui/icons-material';

import {
  getDiagnosisLines,
  getOrderLines
} from './orderSummaryUtils';

import {
  detailTextSx,
  diagnosisDetailsSx,
  diagnosisHeaderSx,
  diagnosisTitleSx,
  editButtonSx,
  editIconSx,
  headerSx,
  orderDetailsSx,
  orderSummaryPaperSx,
  titleSx
} from './OrderSummaryStyles';

const OrderSummary = ({
  title,
  order,
  orderKey,
  onEdit,
  showEdit
}) => {
  if (!order) {
    return null;
  }

  const orderLines = getOrderLines(
    order,
    orderKey
  );

  const diagnosisLines =
    getDiagnosisLines(order);

  if (
    orderLines.length === 0 &&
    diagnosisLines.length === 0
  ) {
    return null;
  }

  return (
    <Paper sx={orderSummaryPaperSx}>
      <Box sx={headerSx}>
        <Typography sx={titleSx}>
          {title}
        </Typography>

        {showEdit && (
          <IconButton
            size="small"
            aria-label={`Edit ${title}`}
            onClick={onEdit}
            sx={editButtonSx}>
            <EditOutlined sx={editIconSx} />
          </IconButton>
        )}
      </Box>

      {orderLines.length > 0 && (
        <Box sx={orderDetailsSx}>
          {orderLines.map(
            (item, index) => (
              <Typography
                key={`${item}-${index}`}
                sx={detailTextSx}>
                {item}
              </Typography>
            )
          )}
        </Box>
      )}

      {diagnosisLines.length > 0 && (
        <>
          <Box sx={diagnosisHeaderSx}>
            <Typography sx={diagnosisTitleSx}>
              Diagnosis Details
            </Typography>
          </Box>

          <Box sx={diagnosisDetailsSx}>
            {diagnosisLines.map(
              (item, index) => (
                <Typography
                  key={`${item}-${index}`}
                  sx={detailTextSx}>
                  {item}
                </Typography>
              )
            )}
          </Box>
        </>
      )}
    </Paper>
  );
};

OrderSummary.propTypes = {
  title: PropTypes.string.isRequired,
  order: PropTypes.object,
  orderKey: PropTypes.string.isRequired,
  onEdit: PropTypes.func,
  showEdit: PropTypes.bool
};

OrderSummary.defaultProps = {
  order: null,
  onEdit: () => {},
  showEdit: true
};

export default OrderSummary;